import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../PricingHub/SearchComponent';

class ClientSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.clientName',
      name: 'clientName',
    },
    {
      label: 'common:label.status',
      name: 'status',
      tOptions: 'selections:timeAndBillingObjectStatus',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.startDateWithRank',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDateWithRank',
      name: 'endDate',
      type: 'date',
    },
  ];

  btnSpan = 'col-md-12';
}

ClientSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

ClientSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(ClientSearchForm);
